<template>
  <v-card :class="resultsMobile ? 'mx-0' : 'mx-3'">
    <v-toolbar color="grey lighten-2" elevation="0">
      <v-icon class="mr-3">mdi-text-box-outline</v-icon>
      <v-toolbar-title class="subtitle-1 font-weight-bold">
        <span
          v-html="
            resultadoBusca.length ? 'Resultado' : 'Nenhuma busca realizada'
          "
        />
        <div class="caption">
          {{ totalRegistros }} resultados em {{ tempoExecucao / 1000 }} segundos
          {{ panelForm }}
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-progress-linear
      :indeterminate="loading"
      :active="loading"
      color="primary"
    ></v-progress-linear>
    <v-card
      class="pa-0 mx-0 overflow-y-auto"
      elevation="0"
      :height="resultsMobile ? height : innerHeight"
    >
      <listagem-documentos
        :listaDocumentos="resultadoBusca"
        @paginar="paginar"
        :isMobile="true"
        :novaBusca="novaBusca"
        :dialogCompartilhamento="dialogCompartilhamento"
      />
    </v-card>
  </v-card>
</template>
<script>
import ListagemDocumentos from "@/shared/ListagemDocumentosJurisprudencia";
export default {
  props: {
    resultadoBusca: { type: Array },
    resultsMobile: { type: Boolean, default: false },
    loading: { type: Boolean },
    termo: { type: String },
    novaBusca: { type: Boolean },
    totalRegistros: { type: Number },
    tempoExecucao: { type: Number },
    dialogCompartilhamento: { type: Boolean },
    panelForm: { type: Number }
  },
  components: {
    ListagemDocumentos
  },
  data() {
    return {
      innerHeight: window.innerHeight - 530 + "px",
      height: window.innerHeight - 114 + "px"
    };
  },
  watch: {
    panelForm: {
      handler() {
        this.innerHeight = window.innerHeight;
        if (this.panelForm == 0) {
          this.innerHeight = this.innerHeight - 530 + "px";
        } else {
          this.innerHeight = this.innerHeight - 327 + "px";
        }
      }
    },
    resultadoBusca: {
      handler() {
        if (this.resultadoBusca) {
          this.resultadoBusca.map(documento => {
            let doc = "";
            if (documento.highlight) {
              documento.highlight.jurisprudencia_decisao.map(descricao => {
                doc += descricao.replace("\n\n", "");
              });
            } else {
              doc =
                documento._source.jurisprudencia_decisao.slice(0, 465) + "...";
            }
            let list_termos = [];
            if (
              documento._source.jurisprudencia_tesauro &&
              documento._source.jurisprudencia_relacionados.length
            ) {
              let termos = documento._source.jurisprudencia_tesauro.split(
                "],["
              );
              termos.map(termo => {
                if (termo) {
                  let new_termo = termo.replace("[", "").replace(",],", "");
                  list_termos.push(new_termo.trim());
                }
              });
              documento.termos = list_termos;
            }
            documento.descricaoFormatada = doc;
            documento.tituloFormatado = this.getTituloFormatado(
              documento._source
            );
          });
        }
      }
    }
  },
  methods: {
    paginar($state) {
      this.$emit("paginar", $state);
    },
    getTituloFormatado(documento) {
      return (
        documento.jurisprudencia_tipo_descricao +
        " " +
        documento.documento_numero_ano +
        " | Relator/Revisor: " +
        documento.processo_relator
      );
    }
    // searchTermo(termo) {
    //   this.$emit("search", { assunto: termo });
    // },
    // searchNormativo(normativo) {
    //   const formNormativo = {
    //     emissor: normativo.emissor ? normativo.emissor : null,
    //     normativo: normativo.normativo ? normativo.normativo : null,
    //     artigo: normativo.artigo ? normativo.artigo : null,
    //     paragrafo: normativo.paragrafo ? normativo.paragrafo : null,
    //     inciso: normativo.inciso ? normativo.inciso : null,
    //     alinea: normativo.alinea ? normativo.alinea : null
    //   };
    //   this.$emit("search", formNormativo);
    // }
  }
};
</script>
